export const Link = 'http://irsystemtuning.ir/'